__turbopack_context__.v({
  "spinner": "styles-module-scss-module__aSI8VG__spinner",
  "spinner__modLg": "styles-module-scss-module__aSI8VG__spinner__modLg",
  "spinner__modMd": "styles-module-scss-module__aSI8VG__spinner__modMd",
  "spinner__modXl": "styles-module-scss-module__aSI8VG__spinner__modXl",
});
